export const IS_LOCALHOST = LOCALHOST
export const LOCALHOST_VERSION = 'localhost'
